import { Endpoint, Http } from "Application/Helpers/BaseEndpoint";
import { AppUrls } from "AppUrls";
import { UpsertStudentSessionRequest } from "./Request";
import { StudentSessionContextByIdResponse } from "../../../../../Student/StudentReports/Endpoints/Shared/StudentSessionContextResponse";

export type { UpsertStudentSessionRequest } from "./Request";
export type { StudentSessionContextByIdResponse } from "../../../../../Student/StudentReports/Endpoints/Shared/StudentSessionContextResponse";

export class UpsertStudentSessionEndpoint extends Endpoint<UpsertStudentSessionRequest, StudentSessionContextByIdResponse> {
    constructor() {
        super();
        this.verb(Http.Post);
        this.path(AppUrls.Server.Student.StudentSessions.PostSaveStudentSession);
    }

    public async HandleRequestAsync(request: UpsertStudentSessionRequest): Promise<UpsertStudentSessionRequest> {
        return request;
    }

    public async HandleResponseAsync(response: StudentSessionContextByIdResponse): Promise<StudentSessionContextByIdResponse> {
        return response;
    }
}
